<template>
    <div class="page-container">
        <div class="page-content">
            <div class="left-side-container">
                <div class="page-header">
                    <h1>{{ $t('Настройки') }}</h1>
                </div>

                <div class="settings-container">
                    <ChangePassword id="change-password" />
                    <PersonalData id="personal-data" />
                    <RegionalData id="regional-data" />
                    <Integration id="integration" />
                    <DataManager id="data-manager" />
                </div>
            </div>

            <div class="right-side-container settings-right-side sticky">
                <RightSideUserControls />

                <div class="list-group">
                    <a href="#" @click.prevent="scrollTo('change-password')" class="list-group-item list-group-item-action">{{ $t('Изменение пароля') }}</a>
                    <a href="#" @click.prevent="scrollTo('personal-data')" class="list-group-item list-group-item-action">{{ $t('Персональные данные') }}</a>
                    <a href="#" @click.prevent="scrollTo('regional-data')" class="list-group-item list-group-item-action">{{ $t('Региональные данные') }}</a>
                    <a href="#" @click.prevent="scrollTo('integration')" class="list-group-item list-group-item-action">{{ $t('Интеграция с банками') }}</a>
                    <a href="#" @click.prevent="scrollTo('data-manager')" class="list-group-item list-group-item-action">{{ $t('Управленние данными') }}</a>
                    <router-link to="/settings/notifications" class="list-group-item list-group-item-action">{{ $t('Оповещения') }}</router-link>
                </div>
                
                <div class="subscription-block">
                    <div class="subscription-block-title">
                        <h3>{{ $t('Подписка') }}</h3>
                    </div>
                    <div class="subscription-block-content">
                        <p>{{ currentSubscription.name }}</p>
                        <p class="subscription-ends-at" v-if="currentSubscription.ends_at">{{ $t('Действует до') }}: <time>{{ currentSubscription.ends_at }}</time></p>
                        <p class="subscription-ends-at" v-else>Бесплатная</p>
                    </div>
                    <router-link to="/subscription" class="subscription-block-action">{{ $t('Управление подпиской') }}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RightSideUserControls from "@/new/components/RightSideUserControls.vue";
import { EventBus } from '../../../event-bus';

import ChangePassword from "@/new/components/Settings/ChangePassword.vue";
import PersonalData from "@/new/components/Settings/PersonalData.vue";
import RegionalData from "@/new/components/Settings/RegionalData.vue";
import Integration from "@/new/components/Settings/Integration.vue";
import DataManager from "@/new/components/Settings/DataManager.vue";

export default {
    name: "Settings",

    components: {
        RightSideUserControls,
        ChangePassword,
        PersonalData,
        RegionalData,
        Integration,
        DataManager
    },

    mounted() {
        this.loadCurrentSubscription();
    },

    data: function() {
        return {
            currentSubscription: {},
        };
    },

    computed: {
        //
    },

    methods: {
        loadCurrentSubscription() {
            axios.get('/subscription/current')
                .then(({data}) => {
                    this.currentSubscription = data.data.plan;
                    this.currentSubscription.ends_at = data.data.ends_at;
                });
        },

        scrollTo(block) {
            const el = document.getElementById(block).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }
    }
}
</script>

<style lang="scss">
.settings-right-side {
    @media (max-width: 768px) {
        display: none;
    }

    .list-group {
        display: flex;
        flex-direction: column;
        padding-left: 0;

        border-radius: 5px;
        background-color: #fff;
        margin: 0 0;

        .list-group-item {
            position: relative;
            display: block;
            padding: 0.75rem 1.25rem;
            background-color: #fff;
            border-bottom: 1px solid #F0F1F7;
            color: #152640;

            &:first-child {
                border-top: none;
                border-top-left-radius: inherit;
                border-top-right-radius: inherit;
            }

            &:last-child {
                border-bottom: none;
                border-bottom-left-radius: inherit;
                border-bottom-right-radius: inherit;
            }

            &:hover {
                background: #f59c25;
                color: #fff;
            }
        }
    }

    .subscription-block {
        width: 100%;
        background: #fff;
        border-radius: 5px;
        margin: 24px 0;

        .subscription-block-title {
            padding: 0.75rem 1.25rem;

            h3 {
                font-size: 15px;
                font-family: 'Proxima Nova Lt';
                font-weight: 600;
                color: #152640;
                margin: 0;
            }
        }

        .subscription-block-content {
            display: flex;
            width: 100%;
            flex-wrap: wrap;
            flex-direction: column;
            padding: 0 1.25rem 0.75rem;
            color: #152640;

            p {
                margin: 0;

                &.subscription-ends-at {
                    font-size: 13px;
                }
            }
        }

        .subscription-block-action {
            position: relative;
            display: block;
            padding: 0.75rem 1.25rem;
            background: #3F6FB7;
            color: #fff;
            border-bottom: 1px solid #F0F1F7;

            &:first-child {
                border-top: none;
                border-top-left-radius: inherit;
                border-top-right-radius: inherit;
            }

            &:last-child {
                border-bottom: none;
                border-bottom-left-radius: inherit;
                border-bottom-right-radius: inherit;
            }

            &:hover {
                background: #f59c25;
            }
        }
    }
}

.settings-container {
    display: flex;
    flex-wrap: wrap;

    .settings-block {
        width: 100%;
        background: #fff;
        border-radius: 5px;
        margin-bottom: 24px;
        padding: 24px 32px;

        .block-header {
            h3 {
                font-size: 18px;
                font-family: 'Proxima Nova Lt';
                font-weight: 600;
                color: #152640;
                margin: 0;
                margin-bottom: 18px;
            }
        }

        .block-content {
            display: flex;
            width: 100%;
            flex-wrap: wrap;

            .form-group {
                width: 100%;
                display: flex;
                align-items: center;

                label {
                    width: 30%;
                }

                .form-control {
                    width: calc(70% - 24px);
                }
            }

            .btn-group {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 10px;

                &.btn-nav-group {
                    justify-content: start;

                    .btn {
                        border-radius: 0;
                        margin: 0;
                        display: flex;
                        align-items: center;

                        &:first-child {
                            border-top-left-radius: 5px;
                            border-bottom-left-radius: 5px;
                        }

                        &:last-child {
                            border-top-right-radius: 5px;
                            border-bottom-right-radius: 5px;
                        }
                    }
                }

                .btn {
                    width: auto;
                }
            }
        }
    }
}
</style>